var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"member_ali_pay_box"},[_c('div',{staticClass:"back_btn",on:{"click":_vm.backPersonal}},[_vm._v("返回个人中心")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.aliWapPayForm)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }